import { Select } from '@brighterion/br-ui';
import { Field, FieldProps } from 'formik';
import React from 'react';

type FormikFieldDropdownProps = {
    name: string;
    className: string;
    id: string;
    placeholder?: string;
    size?: 'sm' | 'lg';
    label?: string;
    children: JSX.Element[];
    index?: number;
    disabled?: boolean;
};

export const FormikFieldDropdown = ({
    id,
    placeholder,
    size,
    label,
    name,
    className,
    children,
    index,
    disabled = false
}: FormikFieldDropdownProps) => {
    return (
        <Field name={name}>
            {({ form, field, meta }: FieldProps) => {
                let selectedItems;
                // if a specific index is given, convert a single value to array
                if (index !== undefined) {
                    selectedItems = field.value ? [field.value] : [];
                } else {
                    selectedItems = field.value ?? [];
                }

                return (
                    <Select
                        id={id}
                        size={size}
                        label={label}
                        dataTestId={id}
                        ariaLabel={id}
                        placeholder={placeholder}
                        className={className}
                        disabled={disabled}
                        onBlur={form.handleBlur}
                        selectedItems={selectedItems}
                        error={!!(meta.error && meta.touched)}
                        errorMsg={meta.error?.toString()}
                        tabIndex={index}
                        // Select component automatically converts selected item into an array
                        // if a specific index is given, convert the value to a single string
                        handleClickCallback={(value: string[]) => {
                            form.setFieldValue(field.name, index !== undefined ? value.toString() : value);
                        }}
                    >
                        {children}
                    </Select>
                );
            }}
        </Field>
    );
};

export default FormikFieldDropdown;
